// export const serverIp = "114.115.205.57:8080"
// export const serverIp = "至孝.top:8080"
export const serverIp = "zhixiao.site:8080"
// export const serverIp = 'localhost:8080'
//TODO 此处在部署时需要修改